/**
 * „Bitte Seite neu laden“ auf Zuruf. (11.10.2026, Ticket 2669)
 *
 * Martin, 26.09., auf der Autobahn: Nach einem Update erscheint der Knopf „Neue Version“ — antippen
 * kann er ihn beim Fahren nicht. Das Modell ruft darum das Werkzeug `app_neu_laden`
 * (tools/app_neu_laden.ts); die App lädt danach über denselben Weg neu wie der Knopf
 * (frontend/lib/app-neu-laden.ts, lib/worker-wechsel.ts).
 *
 * ⚠️ Der Name und der Mindestabstand stehen HIER, weil ihn beide Seiten brauchen: der Server bremst das
 *    Modell, das Gerät bremst sich selbst noch einmal (sessionStorage überlebt das Neuladen).
 */
export const NEU_LADEN_WERKZEUG = "app_neu_laden";

/**
 * Mindestabstand zwischen zwei Aufträgen — am Server je Konto, am Gerät je Sitzung.
 *
 * ⚠️ 15 Sekunden, nicht eine Minute (Prüfbefund zu Ticket 2669): Der Server setzt die Bremse schon beim „ok“. Bricht das
 *    Gerät danach ab (Text im Feld, Anruf, Unruhe) oder ist der Server nicht erreichbar, wurde NICHT geladen. Mit einer
 *    Minute hätte Vespera auf das zweite „lade neu“ sagen müssen, sie habe gerade erst geladen — falsch. 15 s halten ein
 *    festgelaufenes Modell immer noch ab, ohne dass die ehrliche Antwort lange gilt.
 */
export const NEU_LADEN_ABSTAND_MS = 15_000;
